import * as React from 'react'
import { Typography, Grid, Select, 
         FormControl, 
         MenuItem, InputLabel, 
         FormHelperText, Box, Button
         } from '@mui/material'
import { DataGridPro} from '@mui/x-data-grid-pro'
import SendIcon from '@mui/icons-material/Send'
import axios from 'axios'
import { axiosErrorHandling } from '../../misc/other'
import { ErrorAlert } from '../../alerts/ErrorAlert'
import { SuccessAlert } from '../../alerts/Success'
import GroupIcon from '@mui/icons-material/Group';




export const SendMarketingEmail = () =>{

    const [marketingEmails, setMarketingEmails] = React.useState([])
    const [selectedEmailTemplate, setSelectedEmailTemplate] = React.useState('')
    const [selectedCustomerType, setSelectedCustomerType] = React.useState('')
    const [menuItems, setMenuItems] = React.useState(null)
    const [selectedCustomer, setSelectedCustomer ] = React.useState(false)
    const [dirtyForm, setDirtyForm] = React.useState(false)
    const [submiting, setSubmitting] = React.useState(false)
    const [loading, setLoading] = React.useState(false)
    const [error, setError] = React.useState(false)
    const [errorMessage, setErrorMessage] = React.useState('')
    const [dataGrid, setDataGrid] = React.useState(<Grid></Grid>)
    const [customersToSend, setCustomersToSend] = React.useState([])
    const [customersSelected, setCustomersSelected] = React.useState(false)
    const [successAlert, setSuccessAlert] = React.useState(false)
    const [columns, setColumns] = React.useState([
        {field: 'id', headerName: 'ID', flex:1},
        {field: 'first_name', headerName: 'First', flex: 2},
        {field: 'last_name', headerName: 'Last', flex: 2},
        {field: 'email', headerName: 'Email', flex: 2},
        {field: 'email_sent', headerName: 'Campaigns', flex: 2},
        {field: 'last_email_sent', headerName: 'Date', flex: 2},
        {field: 'original_creditor', headerName: 'Account', flex: 2},
        {field: 'original_account_number', headerName:'Account_Number', flex: 2}
    ])
    const closeError = () =>{
        setError(false)
    }
    
    const closeSuccess = () =>{
        setSuccessAlert(false)
    }

const selectChange = (event) => {
    setSelectedEmailTemplate(event.target.value)
    setDirtyForm(true)
    setError(false)
}

const selectCustomerChange = async (event) =>{

    try{
    setSelectedCustomerType(event.target.value)
    setSelectedCustomer(true)
    setError(false)
    setDataGrid(<Grid></Grid>)
    if(event.target.value==='setup'){
        setColumns([{field: 'id', headerName: 'ID', flex:1},
        {field: 'first_name', headerName: 'First', flex: 2},
        {field: 'last_name', headerName: 'Last', flex: 2},
        {field: 'email', headerName: 'Email', flex: 2},
        {field: 'active_accounts', headerName: 'Active Accounts', flex: 2},
        {field: 'email_verified', headerName: 'Verified', flex: 2},
        {field: 'email_sent', headerName: 'Campaigns', flex: 2},
        {field: 'last_email_sent', headerName:'Last Date of Email Sent', flex: 2}

        ])

        axios({
             method: 'POST',
             url: 'api/oracle7/getemailtemplates',
             data: {type: 'active_accounts'}
         }).then(async results=>{
            
            let marketingData = await results.data
            
            setMarketingEmails(marketingData)

         }).catch(err=>{
            throw err
         })
        
    }else{
        setColumns([
        {field: 'id', headerName: 'ID', flex:1},
        {field: 'first_name', headerName: 'First', flex: 2},
        {field: 'last_name', headerName: 'Last', flex: 2},
        {field: 'email', headerName: 'Email', flex: 2},
        {field: 'email_sent', headerName: 'Campaigns', flex: 2},
        {field: 'last_email_sent', headerName: 'Date', flex: 2},
        {field: 'original_creditor', headerName: 'Account', flex: 2},
        {field: 'original_account_number', headerName:'Account_Number', flex: 2}
    ])
    axios({
             method: 'POST',
             url: 'api/oracle7/getemailtemplates',
             data: {type: 'new_accounts'}
         }).then(async results=>{
            
            let marketingData = await results.data
            
            setMarketingEmails(marketingData)

         }).catch(err=>{
            throw err
         })

    }
} catch(err){
     let errMessage = axiosErrorHandling(err)
        setErrorMessage(errMessage)
        setError(true)
}
}

const getCustomers = () =>{
    
    setLoading(true)
    axios({
        method: "POST",
        url: 'api/oracle3/getcustomeremail',
        data: {customer_type: selectedCustomerType}
    }).then( (result)=>{
        
         
        
        if(result.data.length>0){
            
            setDataGrid(<Grid container direction='row'>
                <Grid size={{xs: 12, md: 10}} sx={{mt: 2}}>
                    <DataGridPro 
                    density='comfortable'
                    rows={result.data}
                    columns={columns}
                    checkboxSelection
                    columnBufferPx={150}
                    hideFooter={false}
                    showToolbar
                    slotProps={{toolbar: {showQuickFilter: true}}}
                    onRowSelectionModelChange={(row)=>{ 
                                                         const newArray = Array.from(row.ids)
                                                            if(newArray.length){
                                                                let rowsSelected = []
                                                                setCustomersSelected(true)
                                                                let a = 0
                                                                while(a<result.data.length ){
                                                                    if (newArray.includes(result.data[a].id)){
                                                                        
                                                                        rowsSelected.push(result.data[a])
                                                                        
                                                                    }
                                                                    
                                                                    a++
                                                                }
                                                                
                                                                setCustomersToSend(rowsSelected)
                                                                
                                                            }
                                                            else{
                                                                
                                                                setCustomersSelected(false)
                                                                setCustomersToSend([])
                                                                }
                                                        
                                                            
                                                        }



                                                         }
                    />
                </Grid> 
            </Grid>)
        }
        

    })
    
    setLoading(false)


}

const sendEmailButton =()=>{
    setSubmitting(true)
  
    
    if(selectedCustomerType==='setup'){
        axios({
        method: "POST",
        url: 'api/oracle7/sendemail',
        data: {customers: customersToSend,
               template: selectedEmailTemplate 
         }
    }).then(result=>{
        
        if (result.data==='Email sent'){
            setSuccessAlert(true)
            setSubmitting(false)
            setDataGrid(<Grid></Grid>)
        setSelectedEmailTemplate('')
        setSelectedCustomerType('')
        setCustomersSelected(false)
        setMarketingEmails([])
        setCustomersToSend([])

        }
    }).catch(err=>{
        let message = axiosErrorHandling(err)
        setErrorMessage(message)
        setError(true)
        setSubmitting(false)
        setDataGrid(<Grid></Grid>)
        setSelectedEmailTemplate('')
        setSelectedCustomerType('')
        setCustomersSelected(false)
        setMarketingEmails([])
        setCustomersToSend([])
        

    })


    } else if(selectedCustomerType==='not_active'){
        axios({
        method: "POST",
        url: 'api/oracle7/sendemailstarter',
        data: {customers: customersToSend,
               template: selectedEmailTemplate 
         }
        }).then(result=>{
       
        if (result.data==='Email sent'){
            setSuccessAlert(true)
            setSubmitting(false)
            setDataGrid(<Grid></Grid>)
        setSelectedEmailTemplate('')
        setSelectedCustomerType('')
        setCustomersSelected(false)
        setMarketingEmails([])
        setCustomersToSend([])

        }
    }).catch(err=>{
        let message = axiosErrorHandling(err)
        setErrorMessage(message)
        setError(true)
        setSubmitting(false)
        setDataGrid(<Grid></Grid>)
        setSelectedEmailTemplate('')
        setSelectedCustomerType('')
        setCustomersSelected(false)
        setMarketingEmails([])
        setCustomersToSend([])

    })


    }
    
    
    setSubmitting(false)
    
}


React.useEffect(()=>{
    
    let menuitems = marketingEmails.map((e)=>
        <MenuItem key={e.key} value={e._id}>{e._id} </MenuItem>
    )
    
    setMenuItems(menuitems)
    

},[marketingEmails])

 

    return(
        
        <Box sx={{minHeight:'70vh', mt: 15, mb: 2}}>
            <SuccessAlert message='You have sent emails succesfully' setClose={closeSuccess} open={successAlert} />
            <Grid container direction='column' sx={{mb: 2, justifyContent:'center', alignContent:'center'}}>
                <ErrorAlert open={error} handleClose={closeError} error={errorMessage}/>
                <Grid>
                <FormControl sx={{m: 1, minWidth: 120}}>
                    <InputLabel id='select-email-template-label'>Type of Customer</InputLabel>
                <Select labelID='select-email-template-label'
                id='select-email-template'
                label='Template'
                value={selectedCustomerType}   
                onChange={selectCustomerChange}
                >
                
                <MenuItem value=''><em>None</em></MenuItem>
                <MenuItem value='setup'>Account Set Up</MenuItem>
                <MenuItem value='not_active'>New</MenuItem>

                </Select>
                <FormHelperText> Please select a template</FormHelperText>
                

            </FormControl>

                </Grid>
                <Grid>
                    <Button 
                    variant='contained' 
                    color='primary' 
                    disabled={!selectedCustomer} 
                    endIcon={<GroupIcon />}
                    onClick={getCustomers}
                    loading={loading}
                    loadingPosition='end'
                    >Get Customers</Button>

                </Grid>
                
            </Grid>
            {dataGrid}
        <Grid container direction='column' sx={{justifyContent:'center', alignItems:'center'}}>
        <Grid>
        <Typography sx={{mb: '1rem'}} variant='h4' color='secondary' >Number of Accounts to send: {customersToSend.length} </Typography>
        </Grid>
        <Grid>
        <Typography sx={{mb: '1rem'}} variant='h4' color='secondary' >Please select a Template to send</Typography>
        </Grid>
        <Grid>

            <FormControl sx={{m: 1, minWidth: 120}}>
                <InputLabel id='select-email-template-label'>Template</InputLabel>
                <Select labelID='select-email-template-label'
                id='select-email-template'
                label='Template'
                value={selectedEmailTemplate}
                onChange={selectChange}
                >
                
                <MenuItem value=''><em>None</em></MenuItem>
                {menuItems}

                </Select>
                <FormHelperText> Please select a template</FormHelperText>
                

            </FormControl>
        </Grid>
        <Grid>
        <Button
        sx={{m: 1}}
        variant='contained'
        disabled={!dirtyForm || !customersSelected}
        loading={submiting}
        loadingPosition='end'
        endIcon={<SendIcon/>}
        onClick={sendEmailButton}
        
        >Send Email</Button>
        
        </Grid>
        
        </Grid>
        </Box>
        
        
    )
}